import { useTranslation } from "react-i18next";
import emptyAnimation from '../../../assets/images/loader/empty.json';
import Lottie from "lottie-react";

const EmptyList = () => {
    const { t } = useTranslation('common');

    return (
        <div className="w-full h-full flex flex-col items-center justify-center pb-[50px] xlx:pb-[60px]">
            <Lottie
                animationData={emptyAnimation}
                loop={true}
                autoplay={true}
                className="w-full xlsm:w-[500px] h-[275px] xlsm:h-[350px] mb-[-50px]"
            />
            <h3 className="text-blackDull dark:text-textBlackDull font-bold text-center mb-[20px]">{t("profile.empty")}</h3>
        </div>
    );
};

export default EmptyList;